<script>
    import { Router, Route } from "svelte-routing";
	import Home from "./pages/home.svelte";
    import Help from "./pages/help.svelte";
    import Price from "./pages/price.svelte";
    import Booking from "./pages/booking.svelte"; 
    import { SvelteToast } from '@zerodevx/svelte-toast';


    export const url = "";

    // import Router from 'svelte-spa-router';
    // const routes = {
    //     '/home': Home,
    //     '/how-it-works': Help,
    //     '/pricing': Price
    // }
</script>

<SvelteToast options={{}} />

<Router url="{url}">
    <main>
        <Route path="/"><Home /></Route>
        <Route path="/home"><Home /></Route>
        <Route path="/how-it-works"><Help /></Route>
        <Route path="/features"><Price /></Route>
        <Route path="/booking"><Booking /></Route>
        <!-- <Router {routes} /> -->
    </main>
</Router>